import React from 'react';
import {
    CloseStream,
    RacingStreamWrapperRMG,
    StreamButtonsWrapperRMG,
    StreamIframeWrapperRMG,
    NewStreamRMG,
} from 'src/domains/sportsbook/webview/components/stream/RMG';
import { observer } from 'src/utils/mobx-react';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { useCommon } from 'src/domains/common/Common';
import { AppLayoutsState } from 'src/domains/layouts/state/AppLayouts.state';
import { StreamingState } from 'src/domains/sportsbook/state/streamingState/StreamingState';

interface PropsType {
    isNotificationsList: boolean;
    streamIsInViewport: boolean;
}

export const RacingStreamRMG = observer('RacingStreamRMG', ({ isNotificationsList, streamIsInViewport }: PropsType) => {
    const common = useCommon();
    const appLayoutsState = AppLayoutsState.get(common);
    const { bannersBoxState, notificationsState } = appLayoutsState;
    const streamingState = StreamingState.get(common);
    const starRouter = StarRouter.get(common);

    if (streamingState.openEventId === null) {
        return null;
    }

    const streamEvent = streamingState.getModel(streamingState.openEventId);

    const isOpen = streamingState.isStreamOpen;
    const boxHeight = streamingState.boxHeightHeightRmgRestrictions;

    const renderButtons = (
        <StreamButtonsWrapperRMG isOpen={isOpen}>
            <CloseStream
                isOpen={isOpen}
                onClick={streamingState.closeStream}
            />
        </StreamButtonsWrapperRMG>
    );

    return (
        <RacingStreamWrapperRMG
            ref={streamingState.setStreamingWrapperRef}
            isOpen={isOpen}
            streamIsInViewport={streamIsInViewport}
            isAccountOpen={starRouter.isAccountParam}
        >
            {streamingState.isStreamFloating ? '' : renderButtons}

            <StreamIframeWrapperRMG
                isNotificationAvailable={isNotificationsList === true ? notificationsState.notifications : []}
                bannersHeight={bannersBoxState.boxHeight}
                height={boxHeight}
                isFloating={streamingState.isStreamFloating}
                isOpen={isOpen}
                ref={streamingState.setIframeRef}
                streamIsInViewport={streamIsInViewport}
            >
                {streamingState.isStreamFloating ? renderButtons : ''}
                <NewStreamRMG
                    isStreamFloating={streamingState.isStreamFloating}
                    streamEvent={streamEvent}
                    boxHeight={boxHeight}
                    boxWidth={streamingState.boxWidth}
                    isMobile={streamingState.isMobile}
                />
            </StreamIframeWrapperRMG>
        </RacingStreamWrapperRMG>
    );
});
